import * as type from '../actions/types';

const initialState = {
    data: {},
    loading: false,
    error: null,
    success: null,
}

export default function loginOtpResend(state = initialState, action) {
    switch (action.type) {
        case type.POST_OTP_LOGIN_RESEND_OTP_REQUESTED:
            return {
                ...state,
                loading: true,
                error: null,
                success: null,
            }
        case type.POST_OTP_LOGIN_RESEND_OTP_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.auth,
                success: 'OTP sent to your email and mobile successfully',
                error: null,
            }
        case type.POST_OTP_LOGIN_RESEND_OTP_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: null,
            }
        case type.CLEAR_LOGIN_OTP_RESEND_MESSAGES:
            return {
                ...state,
                error: null,
                success: null,
            }
        default:
            return state
    }
}